import { getMenuVersionConfig } from "../globalData/constant";
import { getLocalStorage } from "./Utils";

/**
 * Get the API URL for a menu, considering version if applicable
 * @param {string} menuName - The menu name (e.g., "PRESCRIPTIONOCR")
 * @param {string} fallbackUrl - Fallback URL if menu doesn't have version support
 * @returns {string} The complete API URL with version if applicable
 */
export const getMenuApiUrl = (menuName, fallbackUrl = "") => {
  const versionConfig = getMenuVersionConfig(menuName);

  // If menu has version support, get version from localStorage and construct URL
  if (versionConfig && versionConfig.hasVersions) {
    const storageKey = `${menuName}_version`;
    const version = getLocalStorage(storageKey) || versionConfig.defaultVersion;
    return versionConfig.getUrl(version);
  }

  // Return fallback URL for menus without version support
  return fallbackUrl;
};

/**
 * Get the current version for a menu
 * @param {string} menuName - The menu name
 * @returns {string|null} The current version or null if not applicable
 */
export const getMenuVersion = (menuName) => {
  const versionConfig = getMenuVersionConfig(menuName);

  if (versionConfig && versionConfig.hasVersions) {
    const storageKey = `${menuName}_version`;
    return getLocalStorage(storageKey) || versionConfig.defaultVersion;
  }

  return null;
};
